import { partnerStrings } from '@data/partners';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${partnerStrings.partner}管理`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  order: 5,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
